import axios from "axios";
import store from "@/store/index";

export default {
  link(payload) {
    const headers = {
      "Content-Type": "application/json",
      "Accept-Language": store.state.Auth.locale,
    };

    if (store.state.Auth.authToken !== null) {
      headers.Authorization = `Bearer ${store.state.Auth.authToken}`;
    }

    return axios.post(
      `${process.env.VUE_APP_API_ENDPOINT_URL}donora_follow_link`,
      payload,
      {
        headers,
        timeout: process.env.VUE_APP_AXIOS_TIMEOUT,
      }
    );
  },
};
